// extracted by mini-css-extract-plugin
module.exports = {"small":"country-flag_small__aNZAX"};